import api from './api';

const apiCall = {

  InvestZenTwo: async (data) => {
    try {
      const response = await api.post('InvestZenTwo', data);
      return response;  
    } catch (error) {
      return false;
    }  
  }

};

export default apiCall;
